//@ts-nocheck - window.obApi events are not typed
const outbrainPixelEvents = {
    signup: () => window.obApi?.('track', 'Email sign up'),
    subscribe: () => window.obApi?.('track', 'Purchase'),
    addToCart: () => window.obApi?.('track', 'Add to cart'),
};

export default outbrainPixelEvents;
